import React, {useState} from 'react';

const Products = (props) => {
    const {
        products    = [],
        order       = {}
    } = props;

    const renderNoItems = () => {
        return (
            <div className={"product-row empty"}>
                <span>No Products</span>
            </div>
        )
    }

    const renderLineItemRow = (index, product) => {
        return (
            <div className={"product-row"} key={product.id}>
                <div className="column name-column">
                    <p className={"m-0"}>{product.name}</p>
                </div>
                <div className="column quantity-column">
                    <p className={"m-0"}>{product.quantity}</p>
                </div>
                <div className="column price-column">
                    <p className={"m-0"}>{product.price}</p>
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            <div className={"m-0 mb-4 quote-products-table"}>
                <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                    <div className={"h5 mb-0 text-eh-navy"}>
                        Products
                    </div>
                </div>
                <div className={"product-table invoice mb-3"}>
                    <div className="header">
                        <div className="column name-column">
                            <span>Product name</span>
                        </div>
                        <div className="column quantity-column">
                            <span>Quantity</span>
                        </div>
                        <div className="column price-column">
                            <span>Price</span>
                        </div>
                    </div>
                    {!!products && products.length > 0 ? products.map((product, index) => renderLineItemRow(index, product)) : renderNoItems()}
                    <div className="footer">
                        <div className="column name-column" />
                        <div className="column quantity-column">
                            <span>Total Product Value</span>
                            <span>Total Invoiced (Excl VAT)</span>
                            <span>Total Invoiced (Incl VAT)</span>
                        </div>
                        <div className="column price-column">
                            <span>{!!order && !!order.total_amount_display ? order.total_amount_display : "-"}</span>
                            <span>{!!order && !!order.total_amount_excl_vat_display ? order.total_amount_excl_vat_display : "-"}</span>
                            <span>{!!order && !!order.total_amount_incl_vat_display ? order.total_amount_incl_vat_display : "-"}</span>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default Products;
